export default "__VITE_ASSET__BezMxJXv__"